import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const insurances = [{
  name: 'Aetna',
  logo: 'https://cdn.magicpatterns.com/uploads/rJXtyaifWMW42RGc4m5KG6/aetna-removebg-preview.png'
}, {
  name: 'VSP',
  logo: 'https://cdn.magicpatterns.com/uploads/fKd6ioDQTFKuCP6K2djLjG/vsp-removebg-preview.png'
}, {
  name: 'NVA',
  logo: 'https://cdn.magicpatterns.com/uploads/kQrDegk5JahZDwfDnAMnX8/nva_logo.png'
}, {
  name: 'Davis Vision',
  logo: 'https://cdn.magicpatterns.com/uploads/bjKq1mDaccPAGmy7ECar7W/davis_vision.png'
}, {
  name: 'EyeMed',
  logo: 'https://cdn.magicpatterns.com/uploads/8Dv3sgU1mnt2S4BKebUzGP/eyemed.png'
}];
export function InsuranceLogos() {
  return <section className="py-16 md:py-20 bg-white border-t border-gray-100" data-id="element-364">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-365">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-366">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block text-brand-gold uppercase tracking-wider text-sm font-bold mb-3" data-id="element-367">
            Trusted by Your Insurance
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-2xl md:text-3xl font-heading font-bold text-brand-dark mb-4" data-id="element-368">
            Insurance Plans We Accept
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-neutral-text/70 max-w-2xl mx-auto" data-id="element-369">
            We work with most major vision and health insurance providers to
            make quality eye care accessible.
          </motion.p>
        </div>

        {/* Logos Grid */}
        <div className="flex flex-wrap justify-center items-center gap-10 md:gap-14 lg:gap-20 mb-12" data-id="element-370">
          {insurances.map((insurance, index) => <motion.div key={insurance.name} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08 + 0.3
        }} whileHover={{
          scale: 1.1,
          y: -4
        }} whileTap={{
          scale: 0.95
        }} className="px-6 py-4 flex flex-col items-center justify-center gap-3 cursor-pointer rounded-card hover:bg-surface-muted hover:shadow-card transition-all duration-300 group" data-id="element-371">
              <img src={insurance.logo} alt={`${insurance.name} logo`} className="h-12 md:h-16 w-auto object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300" loading="lazy" data-id="element-372" />
              <span className="text-xs font-heading font-semibold text-neutral-text/0 group-hover:text-neutral-text/60 transition-colors duration-300" data-id="element-373">
                {insurance.name}
              </span>
            </motion.div>)}
        </div>

        {/* Footer Note */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center" data-id="element-374">
          <p className="text-sm text-neutral-text/60" data-id="element-375">
            Don't see your insurance?{' '}
            <Link to="/contact" className="text-brand-gold font-semibold hover:text-brand-gold-light transition-colors focus-ring rounded-sm px-1 py-0.5" data-id="element-376">
              Contact us
            </Link>{' '}
            — we accept many more plans.
          </p>
        </motion.div>
      </div>
    </section>;
}